import { render, staticRenderFns } from "./afiliadoShowroom.vue?vue&type=template&id=41bf8f82&"
import script from "./afiliadoShowroom.vue?vue&type=script&lang=js&"
export * from "./afiliadoShowroom.vue?vue&type=script&lang=js&"
import style0 from "./afiliadoShowroom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports